module.exports = Studio.libraries['socket.io-client'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['socket.io-client']"
 ** module id = 2
 ** module chunks = 0
 **/